export const FETCH_DEPARTMENTS_COMPLETED = 'FETCH_DEPARTMENTS_COMPLETED';
export const FETCH_DEPARTMENTS_ERROR = 'FETCH_DEPARTMENTS_ERROR';
export const FETCH_DEPARTMENTS_STARTED = 'FETCH_DEPARTMENTS_STARTED';

export const UPDATE_DEPARTMENTS_CURRENT_PAGE = 'UPDATE_DEPARTMENTS_CURRENT_PAGE';
export const UPDATE_DEPARTMENTS_PAGE_SIZE = 'UPDATE_DEPARTMENTS_PAGE_SIZE';

export const ADD_DEPARTMENT_SEARCH = 'ADD_DEPARTMENT_SEARCH';
export const CLEAR_DEPARTMENT_SEARCH = 'CLEAR_DEPARTMENT_SEARCH';

export const CLEAR_DEPARTMENT_COLUMN_SORT = 'CLEAR_DEPARTMENT_COLUMN_SORT';
export const UPDATE_DEPARTMENTS_COLUMN_SORT = 'UPDATE_DEPARTMENTS_COLUMN_SORT';
